import Api from '../Api'

export const getLedger = (userId) => {
    return Api.get('ledger-statement',{ params:{user_id:userId} });
};

export const transferMoney = (money) => {
    return Api.post('money-transfer', money);
}
